module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-3 ma-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": "",
      "pb-3": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.err) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-start": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Position/Name",
      "items": _vm.listItems,
      "hide-details": ""
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pl-2": ""
    }
  }, [(['desktop.image', 'tablet.image'].includes(_vm.formData.name)) ? _c('v-text-field', {
    ref: "fileTextField",
    staticClass: "min-w",
    attrs: {
      "prepend-icon": "attach_file",
      "single-line": "",
      "hide-details": "",
      "label": "Choose Image",
      "required": ""
    },
    on: {
      "click": function($event) {
        return _vm.startInput('imageInput')
      }
    },
    model: {
      value: (_vm.formData.value),
      callback: function($$v) {
        _vm.$set(_vm.formData, "value", $$v)
      },
      expression: "formData.value"
    }
  }) : _vm._e(), _vm._v(" "), (['desktop.image', 'tablet.image'].includes(_vm.formData.name)) ? _c('input', {
    ref: "imageInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange('imageInput', $event)
      }
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "Selected coordinate value",
      "type": "number"
    },
    model: {
      value: (_vm.formData.value),
      callback: function($$v) {
        _vm.$set(_vm.formData, "value", $$v)
      },
      expression: "formData.value"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitHtmlCode()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b824bfc0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/PropertiesModal.vue
// module id = 597
// module chunks = 3